import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

export const enum TruckStatus {
  active = "active",
  archived = "archived",
}

const prettifiedTruckStatus = {
  active: "Active",
  archived: "Archived",
};

export const prettifyTruckStatus = (s: TruckStatus) => {
  return prettifiedTruckStatus[s];
};

export const truckStatusReverseLookup = <{ [key: string]: TruckStatus }>{
  active: TruckStatus.active,
  archived: TruckStatus.archived,
};

export interface TruckParams {
  id: string;
  status: string;
  name: string;
  tare_weight: number;
}

export interface TruckApiParams {
  id: string;
  status: string;
  name: string;
  tare_weight: number;
}

export interface ApiTruck {
  id: string;
  status: string;
  name: string;
  tare_weight: number;
}

export interface FormTruck {
  id: string;
  status: string;
  name: string;
  tareWeight: number;
}

interface hasTruckId {
  truck_id: string;
}

export function buildFormTruck() {
  let formTruck = reactive<FormTruck>({
    id: "",
    status: "active",
    name: "",
    tareWeight: 0,
  });

  let loadTruckIntoForm = (t: Truck, ft: FormTruck) => {
    ft.id = t.id;
    ft.status = t.status;
    ft.name = t.name;
    ft.tareWeight = t.tareWeight;
  };

  let truckStatuses = reactive<TruckStatus[]>([]);

  const loadTruckStatusesIntoForm = (clStatuses: TruckStatus[]) => {
    clStatuses.push(TruckStatus.active, TruckStatus.archived);
  };

  return {
    truckStatuses,
    loadTruckStatusesIntoForm,
    formTruck,
    loadTruckIntoForm,
  };
}

export class Truck {
  id: string;
  status: string;
  name: string;
  tareWeight: number;

  constructor(p: TruckParams) {
    this.id = p.id;
    this.status = p.status;
    this.name = p.name;
    this.tareWeight = p.tare_weight;
  }
}

export function buildFormTruckAutocomplete() {
  let formTruck = reactive<AutocompleteResult>({
    id: "",
    label: "",
  });

  let updateTruck = (
    evt: AutocompleteResult,
    formTruck: AutocompleteResult,
    formData: hasTruckId,
  ) => {
    formTruck.id = evt.id;
    formTruck.label = evt.label;
    formData.truck_id = evt.id;
  };

  return {
    formTruck,
    updateTruck,
  };
}

export function buildNewTruck() {
  return new Truck({
    id: "",
    status: "active",
    tare_weight: 0,
    name: "",
  });
}
